import { jsx as l } from "react/jsx-runtime";
import { DealCard as x } from "../DealCard/index.js";
import { DealFeedCardActions as H } from "../components/DealFeedCardActions/index.js";
const v = ({
  id: t,
  status: o,
  commentCount: D,
  temperature: f,
  voteInfo: c,
  dispatch: e,
  dealUrl: A,
  commentsDealUrl: p,
  isFixedCard: r,
  fixedCardButtonText: s,
  isOnboardingCard: n,
  storeText: C,
  keepMobileLayout: m = !1,
  locale: a,
  cashbackPercentage: g,
  ...j
}) => /* @__PURE__ */ l(
  x,
  {
    id: t,
    status: o,
    dispatch: e,
    bottomContent: /* @__PURE__ */ l(
      H,
      {
        deal: {
          id: t,
          status: o,
          commentCount: D,
          temperature: f
        },
        voteInfo: c,
        actionHandler: e,
        commentsDealUrl: p,
        isOnboardingCard: n,
        isFixedCard: r,
        fixedCardButtonText: s,
        keepMobileLayout: m,
        locale: a
      }
    ),
    dealUrl: A,
    isOnboardingCard: n,
    ...j,
    storeText: C,
    isFixedCard: r,
    keepMobileLayout: m,
    locale: a,
    cashbackPercentage: g
  }
);
export {
  v as DealCardDefault
};
